import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CompactWrapper, ButtonsWrapper, Title } from './styles';
import { Button } from '../../Button';
import { Link } from '../../Link';
import { Markdown } from '../../Markdown';
export var CookieCompact = function (_a) {
  var content = _a.content,
    onConsentClick = _a.onConsentClick,
    onLinkClick = _a.onLinkClick;
  return _jsxs(CompactWrapper, {
    children: [_jsx(Title, {
      el: "h5",
      styleName: "title5",
      children: content.title
    }), _jsx(Markdown, {
      markdown: content.description
    }), _jsxs(ButtonsWrapper, {
      children: [_jsx(Link, {
        onClick: onLinkClick,
        children: content.secondaryCta
      }), _jsx(Button, {
        role: "primary",
        onClick: onConsentClick,
        size: "small",
        children: content.primaryCta
      })]
    })]
  });
};